import { render, staticRenderFns } from "./reAsignaCartera.vue?vue&type=template&id=5c35553c&scoped=true"
import script from "./reAsignaCartera.vue?vue&type=script&lang=js"
export * from "./reAsignaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35553c",
  null
  
)

export default component.exports